import { createTranslations } from '@npco/common-utils-translations'

export const bpayTransferFieldsTranslations = createTranslations({
  linkContact: 'Link to New or Existing Contact',
  billerNotSupported: "This biller isn't supported by Zeller.",
})
